function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SORT_OPTIONS } from './sort-options';
export var getSingleSuburb = localities => {
  var _localities$;
  return (localities === null || localities === void 0 ? void 0 : localities.length) && ((_localities$ = localities[0]) === null || _localities$ === void 0 ? void 0 : _localities$.type) === 'DIVISION' && localities[0];
};
export var getLocalityLabel = _ref => {
  var name = _ref.name,
    metaData = _ref.metaData;
  return "".concat(name, ", ").concat(metaData.state).concat(metaData.postcode ? ", ".concat(metaData.postcode) : '');
};
export var getLocalityDescription = _ref2 => {
  var name = _ref2.name,
    metaData = _ref2.metaData;
  return "".concat(name, ", ").concat(metaData.state).concat(metaData.postcode ? ", ".concat(metaData.postcode) : '');
};
export var getLocalitiesDescription = function getLocalitiesDescription() {
  var localities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return localities.length === 1 ? getLocalityDescription(localities[0]) : "".concat(localities.length, " locations");
};
export var getSuburb = _ref3 => {
  var name = _ref3.name;
  return name;
};
export var getStatsTitle = function getStatsTitle() {
  var localities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SOLD';
  var prefix = SORT_OPTIONS[sortOption].statTitle;
  return prefix + (localities.length === 1 ? getSuburb(localities[0]) : "".concat(getSuburb(localities[0]), " + ").concat(localities.length - 1, " ").concat(localities.length === 2 ? 'location' : 'locations'));
};
export var getLocalitiesWithMore = localities => (localities === null || localities === void 0 ? void 0 : localities.length) > 0 ? "".concat(getLocalityDescription(localities[0])).concat(localities.length > 1 ? " + ".concat(localities.length - 1, " more") : '') : null;
var splitLocalities = (type, string) => string ? string.split(',').map(slug => ({
  type,
  slug
})) : [];
export var fromUrlQuery = (localitySlug, _ref4) => {
  var suburb = _ref4.suburb,
    district = _ref4.district,
    region = _ref4.region;
  return localitySlug ? [{
    slug: localitySlug
  }] : [...splitLocalities('DIVISION', suburb), ...splitLocalities('DISTRICT', district), ...splitLocalities('REGION', region)];
};
var localityToUrl = (key, list) => ({
  [key]: list ? list.join(',') : undefined
});
export var toUrlQuery = localities => {
  var localityMap = localities.reduce((grouped, locality) => {
    /* eslint-disable-next-line no-param-reassign */
    (grouped[locality.type] = grouped[locality.type] || []).push(locality.slug);
    return grouped;
  }, {});
  return _objectSpread(_objectSpread(_objectSpread({}, localityToUrl('suburb', localityMap.DIVISION)), localityToUrl('district', localityMap.DISTRICT)), localityToUrl('region', localityMap.REGION));
};